import app from "../../api/app";

export function createSubmit ( values ) {
    return app.post( "/signup", values ).then(
        response => response.data,
        error => Promise.reject( error.response.data )
    );
}
